import upsertNoteRouteData from "./upsert-note-route";
import listNotes from "./list-notes-route";
import deleteNote from "./delete-notes-route";
import shareNotes from "./share-notes-route";
import getNote from "./get-note-route";

export default {
  "upsert-note": upsertNoteRouteData,
  "list-notes": listNotes,
  "delete-notes": deleteNote,
  "share-notes": shareNotes,
  "get-note": getNote,
};
